import { getFormatter } from '@eih-netbroker/common';
import { useLocale } from '../../../../context/NbLocalizationContext';
import { ValidatedOrder } from '../../services/order/useNormalOrderView';
import { useOrderCurrencyExchangeState } from '../OrderCurrencyExchangeStateContext';
import { OrderConfirmRow } from './OrderConfirmRow';
import classes from './OrderExchangeConfirmView.module.scss';

export type OrderExchangeConfirmViewProps = {
  order: ValidatedOrder;
};

export const OrderExchangeConfirmView = ({ order }: OrderExchangeConfirmViewProps) => {
  const { translation } = useLocale();
  const { formatCurrency, formatNumber, formatDate } = getFormatter();
  const { exchangeSettlementDate } = useOrderCurrencyExchangeState();

  if (order.currencyExchangeParams === 'initialized') {
    return null;
  }

  return (
    <div className={classes.confirm}>
      <p className={classes.confirmTitle}>{translation.orderConfirm.rows.currencyExchangeTitle}</p>
      <OrderConfirmRow
        label={translation.orderConfirm.rows.currency}
        testIdBase="order-confirm-currency-exchange-currency"
        value={order.currencyExchangeParams.sourceCurrency}
      />
      <OrderConfirmRow
        isUppercase
        label={translation.orderConfirm.rows.exchangeDirection}
        testIdBase="order-confirm-currency-exchange-direction"
        value={translation.orderModal.sell}
      />
      <OrderConfirmRow
        label={translation.orderConfirm.rows.quantity}
        testIdBase="order-confirm-currency-exchange-quantity"
        value={formatNumber(order.currencyExchangeParams.sourceAmount)}
      />
      <OrderConfirmRow
        label={translation.orderConfirm.rows.exchangeRate}
        testIdBase="order-confirm-currency-exchange-rate"
        value={formatCurrency(order.currencyExchangeParams.exchangeRate, order.currencyExchangeParams.sourceCurrency)}
      />
      <OrderConfirmRow
        label={translation.orderConfirm.rows.settlementDate}
        testIdBase="order-confirm-currency-exchange-settlement-date"
        value={exchangeSettlementDate.isLoaded ? formatDate(new Date(exchangeSettlementDate.settlementDate)) : '-'}
      />
      <OrderConfirmRow
        label={translation.orderConfirm.rows.currencyExchangeValue}
        testIdBase="order-confirm-currency-exchange-value"
        value={formatCurrency(order.currencyExchangeParams.targetAmount, order.instrument.currency)}
      />
    </div>
  );
};
